// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAutonumeric from 'vue-autonumeric';
import VueClipboard from 'vue-clipboard2';
import VueI18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
import VueLocalStorage from 'vue-ls';
import UploadButton from 'vuetify-upload-button';
import 'vuetify/dist/vuetify.min.css';
import './scss/utility.scss';
import './scss/custom.scss';
// import './assets/font/linear.css';
// import languages from './lang/languages.json';
// import messages from './lang/messages.json';
import numberFormats from './lang/numbers.json';
import dateTimeFormats from './lang/dates.json';
import App from './App';
import router from './router';
import CacheHelper from './util/CacheHelper';
import Constants from './util/Constants';
import FileDownload from './util/FileDownload';
import Formatter from './util/Formatter';
import Util from './util/Util';

Vue.component('vue-autonumeric', VueAutonumeric);

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueClipboard);
Vue.use(VueI18n);
Vue.use(VueLocalStorage, { namespace: 'jmp__' });
Vue.use(CacheHelper);
Vue.use(UploadButton);
Vue.use(Vuelidate);
Vue.use(Vuetify, {
    theme: {
        primary: '#034C89',
        secondary: '#424242',
        accent: '#2093C5',
        error: '#F56C6C',
        info: '#2196F3',
        success: '#67C23A',
        warning: '#E6A23C',
    }
});

Object.defineProperty(Vue.prototype, '$CONST', { value: Constants });
Object.defineProperty(Vue.prototype, '$fileDownload', { value: FileDownload.download });
Object.defineProperty(Vue.prototype, '$format', { value: Formatter });
Object.defineProperty(Vue.prototype, '$has', { value: Util.has });
// Portal IDs:
// 1 - JMP
// 2 - Natal Gaskets
const portalId = 1;
Object.defineProperty(Vue.prototype, '$portalId', { value: portalId });

const isDev = false; // NOTE: CHANGE FOR DEV HERE! Do not change the settings below.
let serverUrl = 'http://localhost:8095'; // DEV
if (!isDev) {
    // PROD
    switch (portalId) {
        case 1: serverUrl = 'https://jmpbiz.co.za'; break;
        case 2: serverUrl = 'https://natalgaskets.co.za'; break;
        case 3: serverUrl = 'http://41.76.214.55:8096'; break;
        default: break;
    }
}

// API base URL.
axios.defaults.baseURL = `${serverUrl}/api`;
// Add a request interceptor to update the last call date.
axios.interceptors.request
    .use(config => {
        Vue.ls.set('LastDt', new Date());
        return config;
    }, error => Promise.reject(error));

Vue.prototype.$_FORMAT_LOCALE = 'en-ZA';
const locale = 'en';
const i18n = new VueI18n({
    locale,
    numberFormats,
    dateTimeFormats
});

if (!RegExp.escape) {
    // $& means the whole matched string
    RegExp.escape = s => s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); // s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// This is a global mixin, it is applied to every vue instance.
let Customer = {};
let Quote = {};
Vue.mixin({
    data() {
        return {
            get CONST() {
                return {
                    SERVER_ROOT: serverUrl
                };
            },
            get ContextCustomer() {
                return Customer;
            },
            set ContextCustomer(customer) {
                if (!customer) customer = {};
                Customer = customer;
            },
            get ContextQuote() {
                return Quote;
            },
            set ContextQuote(quote) {
                if (!quote) quote = {};
                Quote = quote;
            }
        };
    },
    methods: {
        // App is listeting for the JMP_Notification. Will display an alert/snackbar with the options.
        $alert(options) {
            this.$root.$emit('JMP_Notification', options);
        },
        $confirm(options, done) {
            this.$root.$emit('JMP_Confirm', options);
            this.$root.$once('JMP_Confirm_Result', done);
        },
        $prompt(options, done) {
            this.$root.$emit('JMP_Prompt', options);
            this.$root.$once('JMP_Prompt_Result', done);
        },
        $process(options) {
            this.$root.$emit('JMP_Process', options);
        },
        $customer(customer) {
            Customer = customer;
            this.$root.$emit('JMP_Customer', customer);
        },
        $quote(quote) {
            if (quote !== undefined) Quote = quote;
            return Quote;
        }
    }
});

/* eslint-disable no-new */
window.jmpVueInst = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    i18n
});



// WEBPACK FOOTER //
// ./src/main.js